import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { AppStoreProvider } from './stores';
import { TabModel } from '../common/types/TabModel';
import { AccountingStatementAppScreen } from './screens';

interface Props {
    tab: TabModel;
}

const AccountingStatementApp: React.FC<Props> = ({ tab }) => {
    return (
        <AppStoreProvider tab={tab}>
            <AccountingStatementAppScreen />
        </AppStoreProvider>
    );
};

export default observer(AccountingStatementApp);
